import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"
import { useTheme } from "../../styles/ThemeProvider"
import { cn } from "../../lib/utils"

const Progress = React.forwardRef(({ className, value, ...props }, ref) => {
  const { themeObject } = useTheme();
  
  const progressTokens = themeObject.components.progress || {};
  
  const progressRootStyles = {
    position: 'relative',
    height: progressTokens.height || '16px',
    width: '100%',
    overflow: 'hidden',
    borderRadius: progressTokens.borderRadius || themeObject.borderRadius?.full || '9999px',
    backgroundColor: progressTokens.backgroundColor || themeObject.colors.surface.muted,
  };

  const progressIndicatorStyles = {
    height: '100%',
    width: '100%',
    flex: '1 1 0%',
    backgroundColor: progressTokens.indicatorColor || themeObject.colors.primary.main,
    transition: 'all 0.3s ease-in-out',
    transform: `translateX(-${100 - (value || 0)}%)`,
  };

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn("", className)}
      style={progressRootStyles}
      {...props}
    >
      <ProgressPrimitive.Indicator
        style={progressIndicatorStyles}
      />
    </ProgressPrimitive.Root>
  );
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }